import React from "react";
import { IimageSlideComponentProps } from "../types/props";
import {  EDirection } from "../enums";
import closeImage from "../../assets/close.svg";
import ReactTooltip from "react-tooltip";
import { SLIDE_IMAGE_CONFIG } from "../config";
import "./imageSlide.component.scss";

const ImageSlideComponent = ({
  index,
  title,
  id,
  moveSlide,
  removeSlide,
  last,
}: IimageSlideComponentProps) => {
  const up = ():void => {
    moveSlide(index, EDirection.up);
  };
  const down = ():void => {
    moveSlide(index, EDirection.down);
  };
  const remove = ():void => {
    removeSlide(index);
  };

  const getTitleForTooltip = () => {
    // Plain text for the tooltip; DOMParser builds an inert document, so nothing executes
    return new DOMParser().parseFromString(title, 'text/html').body.textContent || '';
  };

  const renderTitle = () => {
    // Handle common HTML entities and tags
    if (title.includes('<sup>') && title.includes('</sup>')) {
      // Split by <sup> tags and render accordingly
      const parts = title.split(/(<sup>.*?<\/sup>)/);
      return parts.map((part, index) => {
        if (part.startsWith('<sup>') && part.endsWith('</sup>')) {
          // Extract content between sup tags
          const supContent = part.replace(/<\/?sup>/g, '');
          return <sup key={index}>{supContent}</sup>;
        }
        return part;
      });
    }
    
    // If no special HTML, return as is
    return title;
  };

  return (
    <>
      <ReactTooltip
        backgroundColor="rgb(0, 51, 89)"
      />
      <div className="image-slide">
        <div className="image-slide--left">
          <div className="image-slide--buttons">
            <button
              className="image-slide--up"
              disabled={index === 0}
              onClick={up}
            >
              <span className="sr-only">Move Up</span>
            </button>
            <button
              className="image-slide--down"
              disabled={last}
              onClick={down}
            >
              <span className="sr-only">Move Down</span>
            </button>
            <span className="image-slide--index">{index + 1}</span>
          </div>
        </div>
        <div className="image-slide--right">
          <button className="image-slide--remove" onClick={remove}>
            <img src={`/dist/${closeImage}`} />
            <span className="sr-only">Remove</span>
          </button>
          <h2 data-tip={getTitleForTooltip().length > 30 ? getTitleForTooltip() : null}>
            {renderTitle()}
          </h2>
          {SLIDE_IMAGE_CONFIG.has(id) && <img src={SLIDE_IMAGE_CONFIG.get(id)} />}
        </div>
      </div>
    </>
  );
};

export default ImageSlideComponent;
